{
    "PageTitle_auth": "Autenticazione",
    "NAME": "Router",
    "PageTitle_presence": "Presenza",
    "PageTitle_changePassword": "Cambiare la password",
    "PageTitle_forgotPassword": "Ha dimenticato la password",
    "PageTitle_changeLanguage": "Cambia lingua",
    "PageTitle_resetPassword": "Reimposta password",
    "PageTitle_termsAndConditions": "Termini e Condizioni",
    "PageTitle_cookiePolicy": "Informativa sui cookie",
    "PageTitle_privacyPolicy": "politica sulla riservatezza",
    "PageTitle_mfa": "Autenticazione a più fattori",
    "PageTitle_teamsAuth": "Autenticazione Teams",
    "PageTitle_insights": "Approfondimenti",
    "PageTitle_crmIntegration": "Integrazione CRM",
    "PageTitle_changeUserAgent": "Cambia agente utente",
    "PageTitle_clientConfiguration": "Configurazione del cliente",
    "PageTitle_CRMConfiguration": "Configurazione CRM",
    "PageTitle_adminControl": "Controlli amministrativi"
}